<a *ngIf="false" class="event-log-menu-filter" href="">
    <i class="bz-icon bz-icon-filter"></i>
</a>